import i18n from '~/translations';

export const CURRENT_PLAN_FEATURES = [
  i18n.t('cancelSubscription.unlimitedCloudRuns', 'Unlimited cloud runs'),
  i18n.t('cancelSubscription.unlimitedUsers', 'Unlimited users'),
  i18n.t('cancelSubscription.notifications', 'Notifications'),
  i18n.t('cancelSubscription.schedules', 'Schedules'),
  i18n.t('cancelSubscription.variables', 'Variables'),
  i18n.t('cancelSubscription.reporting', 'Reporting'),
  i18n.t('cancelSubscription.muchMore', 'And much more!'),
];

export const LOST_FEATURES = [
  i18n.t('cancelSubscription.noCloudRuns', 'No cloud runs'),
  i18n.t('cancelSubscription.noNotifications', 'No notifications'),
  i18n.t('cancelSubscription.noSchedules', 'No schedules'),
  i18n.t('cancelSubscription.noVariables', 'No variables'),
  i18n.t('cancelSubscription.noReporting', 'No reporting'),
];
